import { render } from "./CriarListarEditar.vue?vue&type=template&id=02c6ac1e&scoped=true"
import script from "./CriarListarEditar.vue?vue&type=script&lang=js"
export * from "./CriarListarEditar.vue?vue&type=script&lang=js"

import "./CriarListarEditar.vue?vue&type=style&index=0&id=02c6ac1e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c6ac1e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QBtn,QTooltip,QTd});
